import { LLMConfigContainer } from '@/modules/LLMConfig';

export const LLMConfig = (): JSX.Element => <LLMConfigContainer />;

export default LLMConfig;
